export default __webpack_public_path__ + "static/media/netlify.cf3d3121.svg";